import { render, staticRenderFns } from "./ProvinceList.vue?vue&type=template&id=8db94998&scoped=true&"
import script from "./ProvinceList.vue?vue&type=script&lang=js&"
export * from "./ProvinceList.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceList.vue?vue&type=style&index=0&id=8db94998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db94998",
  null
  
)

export default component.exports